import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const MainSection = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  max-width: 59rem;
  margin-top: 3.2rem;
  @media ${(props) => props.theme.media.lg} {
    flex-wrap: wrap;
    max-width: 100%;
  }
`

export const TitleSearchWrap = styled.div`
  flex-basis: 29rem;
  @media ${(props) => props.theme.media.lg} {
    flex-grow: 1;
  }

  & > h1 {
    font-size: 3.5rem;
    font-family: 'Montserrat';
    font-weight: 900;
    line-height: 3.5rem;
    background: linear-gradient(135deg, #0e54a0 30%, #00c2fb 70%);
    background-position: center center;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    @media ${(props) => props.theme.media.md} {
      font-size: 2.8rem;
      line-height: 2.5rem;
    }
  }
  & > h2 {
    font-size: 0.9rem;
    color: #003893;
    margin-top: 0.4rem;
    font-family: 'Montserrat';
    font-weight: 700;
    line-height: 1.4rem;
    @media ${(props) => props.theme.media.md} {
      font-size: 1.4rem;
      padding: 1rem 0;
    }
  }
`
export const ChartErrorWrap = styled.div`
  height: 11.5rem;
  width: 540px;
  display: flex;
  overflow: auto;
  justify-content: center;
  align-items: center;
  padding: 0 1.5rem;
  font-size: 0.8rem;
`
export const ChartMainWrap = styled.div`
  flex-basis: 29rem;
  max-width: 29rem;
  height: 100%;
  margin-left: 1rem;

  @media ${(props) => props.theme.media.lg} {
    flex-grow: 1;
    max-width: 100%;
    margin-left: 0rem;
  }
`
export const ChartInnerWrap = styled.div`
  background-color: #fff;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  box-shadow: 0 0.15rem 0.3rem #ccc;
  padding: 0 1rem;
  & > h3 {
    font-size: 0.8rem;
    color: #1d1d1d;
    padding: 1.5rem 0 1.5rem 1.5rem;
    margin-left: -1rem;
    font-family: 'Montserrat';
  }
`
export const SearchBoxWrap = styled.div`
  width: 100%;
`

export const TableLink = styled(Link)`
  color: #0097fe;
  font-family: Roboto;
  font-weight: 400;
  &:hover {
    color: #003893;
  }
`
